import type { TaskAmountExtract } from '../types';

/**
 * The current best amounts to DISPLAY for a reconciliation row: filed (actual, source of truth)
 * when present, else computed (POS draft), else the legacy `amounts` bag (migrated/old rows).
 * "Present" = has at least one key. Returns a shallow copy ({} for a missing extract).
 */
export function displayAmounts(
  extract?: TaskAmountExtract | null,
): Record<string, number | null> {
  if (!extract) return {};
  const filed = extract.filed ?? {};
  if (Object.keys(filed).length > 0) return { ...filed };
  const computed = extract.computed ?? {};
  if (Object.keys(computed).length > 0) return { ...computed };
  return { ...(extract.amounts ?? {}) };
}

/**
 * The FILED figures only: filed when present, else the legacy `amounts` bag (old and extracted rows hold real figures
 * there), else {}. Never the computed draft. Ruling 2026-10-26 (DP-GRADE-PREFILL): the automated estimate is not used for
 * filing, so nothing seeds, shows or stamps it as a filed value.
 */
export function filedAmounts(
  extract?: TaskAmountExtract | null,
): Record<string, number | null> {
  if (!extract) return {};
  const filed = extract.filed ?? {};
  if (Object.keys(filed).length > 0) return { ...filed };
  return { ...(extract.amounts ?? {}) };
}
